import classNames from 'classnames';
import { CheckIcon, PauseIcon } from 'tdesign-icons-react';

import { AddGrey, FilePlayIcon } from '@/components/icon';
import { Voice } from '@/interface/aigc';

import styles from './index.module.less';

interface IProps {
  data: Voice;
  selectedVoice?: Voice;
  isPlaying: boolean;
  onPlayAudio: (voice: Voice) => void;
}

const VoiceCard: React.FC<IProps> = (props) => {
  const { data, selectedVoice, isPlaying = false, onPlayAudio } = props;
  const { voiceId: id = '', voiceName: name = '未命名', tag = [] } = data || {};
  const isSelected = selectedVoice?.voiceId === id;

  const handlePlay = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    onPlayAudio(data);
  };

  return (
    <div className={classNames(styles.wrapper, { [styles.selected]: isSelected })}>
      <div className={styles.header}>
        <div className={styles.left}>
          <div className={styles.play} onClick={handlePlay}>
            {isPlaying
              ? <PauseIcon size={24} />
              : <FilePlayIcon style={{ width: 24, height: 24 }} />}
          </div>
          {name}
        </div>
        <div className={styles.right}>
          {isSelected ? <CheckIcon color={'#FFFFFF'} /> : <AddGrey />}
        </div>
      </div>
      <div className={styles.tags}>
        {tag.map((e, i) => <div key={i} className={styles.tag}>{e}</div>)}
      </div>
    </div>
  );
};

export default VoiceCard;
